import styles from "../upsc-admission-anna-nagar/upsc-ias-ips-admission.module.css";
import ReCAPTCHA from "react-google-recaptcha";
import { createUser } from "../../components/Service/Userservice";
import { useState } from "react";
import dynamic from 'next/dynamic';
const Otpverification = dynamic(() => import("../../components/Modal/Otpverification"));
const Classroom_form = (props) => {


    const [verified, setverified] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [modalOtp, setModalOtp] = useState(false);
    const [modalOtpstatus, setmodalOtpstatus] = useState(null);
    const [modalOtpExceptionMessage, setmodalOtpExceptionMessage] = useState('');
    const [valuephno, setvaluephno] = useState(undefined);
    const [captchaerror, setcaptchaerror] = useState(undefined);
    const [selectedRadio, setSelectedRadio] = useState();

    const HandleChangeValue = (e) => {
        setSelectedRadio(e.target.value);
        if (e.target.value == 'Online'){
            document.getElementById("branch").value = ''
        }
    };

    function onChange(value) {
        if (value == null) {
            setverified(false);
        }
        else {
            setverified(true);
        }
    }

    async function handleOnSubmit(e) {
        e.preventDefault();
        if (verified) {
            const formData = {};
            formData['formType'] = "AllIndiaPrelimsMockTest";
            formData['title'] = "All India Prelims Mock Test";
            formData['branch'] = props.branchname;
            Array.from(e.currentTarget.elements).forEach(field => {
                if (!field.name) return;
                if (field.type === "radio") {
                    if (field.checked) {
                        formData[field.name] = field.value;
                    }
                } else {
                    formData[field.name] = field.value;
                }
            });
            formData['countryCode'] = "+91";
            formData['phoneNo'] = formData['phoneNo'].substring(formData['phoneNo'].indexOf(' ') + 1).trim().replace(/[^0-9]/g, "");
            setIsLoading(true);

            createUser(formData)
                .then(response => {
                    setModalOtp(true);
                    setmodalOtpstatus(response.message);
                    window.grecaptcha.reset(setverified);
                    setverified(false);
                    setvaluephno(undefined);
                    document.getElementById("allindiaprelims").reset();
                    setIsLoading(false);
                })
                .catch(error => {
                    setModalOtp(true);
                    setmodalOtpstatus("failure");
                    setmodalOtpExceptionMessage(error.message.split("Error: ")[1]);
                    window.grecaptcha.reset(setverified);
                    setverified(false);
                    setIsLoading(false);
                })

        }
        else {
            setcaptchaerror(true);
            setTimeout(() => {
                setcaptchaerror(false);
            }, 3000);
        }
    }
    return (
        <>

            {isLoading &&
                <div class="APIPreLoader" id="APIPreLoader">
                    <div class="loader">Loading...</div>
                </div>
            }
            <Otpverification show={modalOtp} title={modalOtpstatus} exceptionMessage={modalOtpExceptionMessage} frompage="allIndiaPrelimsMockTest" onHide={() => setModalOtp(false)} />
            <div className="container-fluid pt-3">
                <div className="row mx-auto pt-3" style={{ background: "#FFF2F2 0% 0% no-repeat padding-box", opacity: "1" }}>
                    <div className="col">

                    <div className="container pt-4">

                        <div className="row">

                            <div className="col-12 mx-auto">
                                <h1 className={`${styles.contactheader}`}>Registration Details&nbsp;&nbsp;&nbsp;<span className={`${styles.acheiverrank2} mb-0`} style={{color: '#DB1B0D'}}>Registration is mandatory to attend the SIA All India Prelims Mock Test 2024</span></h1>
                                <form onSubmit={handleOnSubmit} id="allindiaprelims" autoComplete="off">

                                    <div className="row pt-4">

                                        <div className="col-12 col-xl-3 col-lg-4">
                                            <div className="mb-4">
                                                <input type="text" className={`${styles.acheiverrank1} form-control`} placeholder="Name" autoComplete="off" name="name" minLength="1" required />
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-4">
                                            <div className="mb-4">
                                                <input type="email" className={`${styles.acheiverrank1} form-control`} placeholder="Email Address" title="Please enter a valid email address" autoComplete="off" name="emailAddress" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$" aria-describedby="emailHelp" required />
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-4">
                                            <div className="mb-4">
                                                <input type="tel" className={`${styles.acheiverrank1} form-control`} name="phoneNo" placeholder="Phone No" pattern="[0-9]{10}" maxlength="10" required />
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-6 pt-3">

                                            <label className={`${styles.acheiverrank1} form-check-label px-2`}>Mode</label>
                                            <input className="form-check-input" type="radio"
                                                name="mode"
                                                value={"Online"}
                                                id="Online"
                                                required
                                                onChange={HandleChangeValue}
                                            />
                                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="Online"> Online</label>
                                            <input className="form-check-input" type="radio"
                                                name="mode"
                                                value={"Offline"}
                                                id="Offline"
                                                required
                                                onChange={HandleChangeValue}
                                            />
                                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="Offline">Offline</label>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-6 pt-3">
                                        <div className="mb-4">
                                            <select disabled={selectedRadio ===  'Online' ? 'Offline' : ''} className={`${styles.acheiverrank} form-select form-control`} id="branch" name="branch" autoComplete="off" required>
                                            <option value="" selected>Select Center</option>
                                            <option value="Chennai-Annanagar">Annanagar</option>
                                            <option value="Chennai-Adyar">Adyar</option>
                                            <option value="Delhi">Delhi</option>
                                            <option value="Bengaluru">Bengaluru</option>
                                            <option value="Thiruvananthapuram">Thiruvananthapuram</option>
                                            <option value="Hyderabad">Hyderabad</option>
                                            <option value="Kolkata">Kolkata</option>
                                            <option value="Shillong-Meghalaya">Shillong-Meghalaya</option>
                                            {/* <option value="Online">Online</option> */}
                                            <option value="Trichy">Trichy</option>
                                            <option value="Salem">Salem</option>
                                            <option value="Madurai">Madurai</option>                                         
                                            <option value="Coimbatore">Coimbatore</option>
                                            </select>
                                        </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-6 pt-3">
                                        <div className="mb-4">
                                        <select className={`${styles.acheiverrank} form-select form-control`} name="optionalForCsm" autoComplete="off" required>
                                            <option value="" disabled selected hidden>Choose your Optionals for CSM</option>
                                            <option value="Economics">Economics</option>
                                            <option value="Geography">Geography</option>
                                            <option value="Indian History">Indian History</option>
                                            <option value="Philosophy">Philosophy</option>
                                            <option value="Political Science">Political Science</option>
                                            <option value="Psychology">Psychology</option>
                                            <option value="Public Administration">Public Administration</option>
                                            <option value="Sociology">Sociology</option><option value="Law">Law</option>
                                            <option value="Agriculture">Agriculture</option>
                                            <option value="Animal Husbandry and Veterinary Science">Animal Husbandry and Veterinary Science</option><option value="Botany">Botany</option>
                                            <option value="Chemistry">Chemistry</option>
                                            <option value="Mathematics">Mathematics</option>
                                            <option value="Statistics">Statistics</option>
                                            <option value="Medical Science">Medical Science</option>
                                            <option value="Physics">Physics</option>
                                            <option value="Zoology">Zoology</option>
                                            <option value="Anthropology">Anthropology</option>
                                            <option value="Geology">Geology</option>
                                            <option value="Civil Engineering">Civil Engineering</option>
                                            <option value="Electrical Engineering">Electrical Engineering</option><option value="Mechanical Engineering">Mechanical Engineering</option>
                                            <option value="Commerce">Commerce</option>
                                            <option value="Management">Management</option>
                                            <option value="Literature">Literature</option>
                                            </select>
                                        </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-6 pt-3">
                                        <div className="mb-4">
                                          <select className={`${styles.acheiverrank} form-select form-control`} name="associationWithSiaProgram" autoComplete="off" required>
                                            <option value="" disabled selected hidden>Association with SIA Program?</option>
                                            <option value="GS-PCM">GS-PCM</option>
                                            <option value="GS-Preliminary">GS-Preliminary</option>
                                            <option value="Prestorming">Prestorming</option>
                                            <option value="Prefit">Prefit</option>
                                            <option value="Mains Crash Course">Mains Crash Course</option>
                                            <option value="Mainstorming">Mainstorming/Moksha</option>
                                            <option value="New To SIA">New To SIA</option>
                                            <option value="Others">Others</option>
                                            </select>
                                        </div>
                                        </div>
                                        
                                        <div className="col-12 col-xl-6 pt-3">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id={styles.invalidCheck2} />
                                            <label className={`${styles.checkboxcontent} form-check-label`} htmlFor="invalidCheck2">
                                                I would like to receive updates from Shankar IAS Academy
                                            </label>
                                        </div>


                                        <div className="d-flex flex-wrap mb-3">
                                            <div className="me-3 mt-2">
                                                <ReCAPTCHA className={`${styles.captcha}`}
                                                    sitekey="6LcnfZ0lAAAAAJgHlHwqnKD926Gcgu6jlrHRgMQI"
                                                    onChange={onChange}

                                                />
                                                <div className="">
                                                    {captchaerror && <div className="text-danger text-center captachafont">Please verify the captcha!</div>}
                                                </div>
                                            </div>

                                            <div className="my-auto">
                                                <p className="mt-3"><button className={`${styles.normalbutton}`} type="submit">Send</button></p>
                                            </div>
                                        </div>
                                    </div>

                                    </div>
                                   


                                </form>

                            </div>

                        </div>

                    </div>

                    </div>
                </div>
            </div>

        </>
    )
}
export default Classroom_form;